module.exports = __webpack_public_path__ + "img/equity_icon18.c0cb81b9.png";